module.exports = __webpack_public_path__ + "static/media/dayana.f16e5e8c.png";